<template>
  <div class="modal is-active"
       :class="{'nested-modal': needNestedModalFix }">
    <div class="modal-background"
         @click="saveAndCloseActive" />
    <button class="close-modal"
            :class="{'iphoneFix' : isIphone}"
            @click="saveAndCloseActive"
            aria-label="close">
      <i class="fal fa-times fa-3x" qa="close-post"/>
    </button>
    <span v-if="displayPosts && displayPosts.length > 1 && modalArrow"
          class="modal-arrow_container">
      <button class="modal-arrow"
              @click="getPostDirection('prev')" :style="{ visibility: !isFirstPost ? 'visible' : 'hidden' }">
        <i class="fal fa-chevron-left" />
      </button>
      <button class="modal-arrow" judge-on-boarding="step-3" :style="{ visibility: !isLastPost ? 'visible' : 'hidden' }"
              @click="getPostDirection('next')">
        <i class="fal fa-chevron-right" />
      </button>
    </span>
    <div ref="gridModal"
         class="modal-content"
         tabindex="0"
         @keyup="processKeys"
         :class="{ 'ios-fix' : iosMobile }">
      <list v-if="post"
            ref="list"
            :post="post"
            :isGrid="true"
            :gridRef="$refs.gridModal"
            :members="members"
            @deleteProject="closeActive"
            @closeActive="closeActive"
            :selectedCommentID="selectedCommentID"
            :getPostDirection="getPostDirection"
            :isSnapshot="isSnapshot" />
    </div>
  </div>
</template>

<script>
import List from './List'

import componentState from '@/mixins/component-state'
import state from '../state'

import userAgent from '@/libs/user-agent'
import judgeOnboardingSteps from '@/mixins/judge-onboarding-steps'

export default {
  props: {
    postID: Number,
    scrollToComment: Object,
    selectedCommentID: String,
    getPostDirection: Function,
    displayPosts: Array,
    fromStartButtonTemplate: Boolean,
    isSnapshot: Boolean
  },
  data: function () {
    return {
      modalArrow: this.enableModalArrows()
    }
  },
  mixins: [componentState, judgeOnboardingSteps],
  components: {
    List
  },
  computed: {
    attachModal: function () {
      return this.$store.getters.modalIsVisible('attach') || this.$store.getters.modalIsVisible('whiteboard')
    },
    post: function () {
      return this.$store.state.post.posts[this.postID]
    },
    postMembers: function () {
      if (this.post.isPrivate && this.$store.getters.allPostmembership(this.post.id) && this._get('isSameAsProject')) {
        return Object.values(this.$store.getters.allPostmembership(this.post.id))
      } else {
        return Object.values(this.$store.state.project.projectMembers[this.post.projectID])
      }
    },
    members: function () {
      if (this.post.isPrivate && this.$store.getters.allPostmembership(this.post.id) && this._get('isSameAsProject')) {
        return Object.values(this.$store.getters.allPostmembership(this.post.id))
      } else {
        return Object.values(this.$store.state.project.projectMembers[this.post.projectID])
      }
    },
    // Edge case for iOS bug while viewing the expanded carousel preview images (a modal) from the grid modal
    needNestedModalFix: function () {
      return this._get('carouselPreview', false) && this.iosMobile
    },
    iosMobile: function () {
      return userAgent.isIOS()
    },
    tourStatus: function () {
      return this.$tours.onboarding._data.currentStep
    },
    isFirstPost: function () {
      if (this.displayPosts && this.displayPosts.length > 0 && this.postID) {
        return this.displayPosts[0].id === this.postID
      }
      return false
    },
    isLastPost: function () {
      if (this.displayPosts && this.displayPosts.length > 0 && this.postID) {
        return this.displayPosts[this.displayPosts.length - 1].id === this.postID
      }
      return false
    },
    isIphone: function () {
      return !!navigator.platform && /iPhone/.test(navigator.platform)
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.scrollToCommentSection()
      this.$refs.gridModal.focus()
    })
    this.$store.dispatch('getPostMembers', { post: this.post, limit: 20, offset: 0 })
    console.log(!!navigator.platform && /iPhone/.test(navigator.platform))
  },
  watch: {
    tourStatus: function (value, oldValue) {
      if ((value === this.JudgeOnboardingStep3 && oldValue === this.JudgeOnboardingStep2) ||
          (value === this.JudgeOnboardingStep0 && oldValue === this.JudgeOnboardingStep1)) {
        this.$emit('toggleAvailability', false)
      }
    }
  },
  methods: {
    processKeys (e) {
      switch (e.keyCode) {
        case 27:
          this.saveAndCloseActive()
          break
        case 39:
          if (!this.isLastPost && this.enableModalArrows()) {
            this.getPostDirection('next')
          }
          break
        case 37:
          if (!this.isFirstPost && this.enableModalArrows()) {
            this.getPostDirection('prev')
          }
          break
      }
    },
    enableModalArrows: function () {
      return !this.fromStartButtonTemplate
    },
    closeActive: function () {
      if (this.$route.query.postID || this.$route.query.commentID) {
        const query = Object.assign({}, this.$route.query)
        delete query.postID
        delete query.commentID
        delete query.reply
        this.$router.replace({ query })
        this.$emit('scrollToPost', this.postID)
      }

      this._set(state.grid.modalVisible, false)
      this._delete(state.comments.scrollTo(this.postID))
    },
    saveAndCloseActive: function () {
      if (this.post.project && this.post.project.displayType === 'registrationForm') {
        this.$store.dispatch('getPollUserOptionSummaries', { projectId: this.post.projectID })
      }
      if (this.$route.params.startButton === true) {
        if (this.$refs.list.$refs.reply) {
          this.$store.dispatch('updatePostBody', { id: this.postID, body: this.$refs.list.$refs.reply.body })
        }
        this.closeActive()
      } else {
        this.closeActive()
      }
    },
    scrollToCommentSection: function () {
      if (this.scrollToComment) {
        this.$nextTick(() => {
          this.$refs.list.$refs.comments.$refs.add.$el.scrollIntoView({ behavior: 'auto', block: 'end' }) // First scroll Into view is to fetch comments
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.modal-background {
  background-color: rgba(10, 10, 10, 0.50);
}

.close-modal {
  background: none;
  height: 40px;
  z-index: 1;
  width: 66vw;
  text-align: right;
  color:#fff;
  border:transparent;
  cursor: pointer;
  @include mobile {
    width: 100vw;
  }
  @include tablet-only {
    width: 90vw;
  }
  .far {
    -webkit-text-stroke: 1px rgb(255,255,255);
  }
  &:focus,
  &:active {
    outline: 0;
  }
}
.modal {
  &-content {
    background-color:#fff;
    width: 60vw;
    margin: 0;
    overflow-x: hidden;
    .main-container{
      border-top: 0;
    }
    @include fullhd {
      max-width: 900px;
    }
    @include tablet-only {
      width: 90%;
    }
    @include mobile{
      width: 100vw;
      max-height: 75vh;
      margin: 0 10px;
    }
  }
  &-arrow {
    font-size: 6em;
    background: transparent;
    border: none;
    color: #F2F2F2;
    cursor: pointer;
    opacity: .5;
    &_container{
      max-width: 1100px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      position: fixed;
      @include tablet-only() {
        width: 100vw;
        font-size: .5em;
        opacity: 1;
        color: #F2F2F2;
      }
      @include mobile() {
        display: none;
      }
    }
    &:hover {
      opacity: 1;
    }
  }
}

.ios-fix {
  top: 0;
  max-height: 90%;
  margin-bottom: 20px;
  padding-top: 9vh;
}

.iphoneFix {
  margin-top: 4.5rem;
  margin-bottom: 1rem;
}

.nested-modal {
  .modal-content {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    max-height: 100vh;
  }
  .close-modal {
    display: none;
  }
}

</style>
